export class Menu{
  title: string
  icon: string
  toUrl: string

  constructor(title: string, icon: string, toUrl: string){
    this.title = title;
    this.icon = icon;
    this.toUrl = toUrl;
  }
}